import React from "react";
import "./PrintablePrescription.css";

export const PrintablePrescription = props => {
    const prescription = props.prescription;

    return (<iframe id={'prescription' + prescription.id} src={window.URL.createObjectURL(prescription.pdfData)}
                    width="1000px" height="800px"></iframe>);
}